import { useState } from 'react'
import { Box, Typography, MenuItem, Select } from '@mui/material'

import { myFunctions } from '../../firebase'

import { GenerateWithAIForm } from './GenerateWithAIForm'

function RubricEditorSettings({
  onUpdateRubric = () => {},
  rubric,
  loadingRubric = false,
  setLoadingRubric = () => {},
}) {
  const [refinementPrompt, setRefinementPrompt] = useState('')
  const [loading, setLoading] = useState(false)
  const [publicRubric, setPublic] = useState(false)
  const [rubricSettings, setSettings] = useState({
    sort: rubric?.sort || 'asc',
    start: rubric?.start || 0,
  })
  const settings = [
    {
      label: 'Sort score definitions',
      key: 'sort',
      options: [
        {
          label: 'Ascending',
          value: 'asc',
        },
        {
          label: 'Descending',
          value: 'desc',
        },
      ],
      onSelect: e => {
        console.log(e.target.value)
        setSettings({
          ...rubricSettings,
          sort: e.target.value,
        })
        onUpdateRubric({
          sort: e.target.value,
        })
      },
    },
    {
      label: 'Start scores from...',
      key: 'start',
      options: [
        {
          label: 'Zero',
          value: 0,
        },
        {
          label: 'One',
          value: 1,
        },
      ],
      onSelect: e => {
        console.log(e.target.value)
        setSettings({
          ...rubricSettings,
          start: e.target.value,
        })
        changeStartFromScores(e.target.value)
      },
    },
  ]

  const changeStartFromScores = startFrom => {
    const criteria = rubric.criteria.map(criterion => {
      const score_definitions = criterion.score_definitions.map((score, index) => {
        const level = startFrom === 1 ? index + 1 : index

        return {
          ...score,
          level,
        }
      })

      return {
        ...criterion,
        score_definitions,
      }
    })

    onUpdateRubric({
      criteria,
      start: startFrom,
    })
  }

  const updateRubric = async () => {
    setLoading(true)
    setLoadingRubric(true)
    let messages = [
      {
        role: 'system',
        content: `
					Use will recieve a rubric from a teacher. They will be asking you to make some changes to the rubric. Based on their feedback return the JSON format of the rubric. as you are given. If they ask for more criteria or score_definitions, you can add them as well. Only modify specifically what they ask for. Other than that, you should not change the rubric.
					
					FEEDBACK ON THE RUBRIC: ${refinementPrompt}

					JSON FORMAT: ${JSON.stringify({
            criteria: rubric.criteria,
            name: rubric.name,
            description: rubric.description,
            score_titles: rubric.score_titles,
          })}
					`,
      },
    ]
    const { data } = await myFunctions.createChatCompletion({
      chat: {
        model: 'gpt-4o',
        response_format: { type: 'json_object' },
        messages: messages,
      },
    })
    const newRubric = JSON.parse(data?.response?.content)

    onUpdateRubric({
      ...newRubric,
      ...rubricSettings,
    })
    setLoading(false)
    setRefinementPrompt('')
    setLoadingRubric(false)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: 2,
      }}
    >
      <Box>
        <Typography fontSize={24} fontWeight={600}>
          Rubric Settings
        </Typography>
        <Typography color="text.secondary" fontSize={14} fontWeight={400}>
          Refine your rubric manually in the builder to the right, or refine it using AI.
        </Typography>
      </Box>
      <GenerateWithAIForm
        buttonText="Update"
        loading={loading}
        placeholder="How would you like to refine your rubric?"
        type="update"
        value={refinementPrompt}
        onChange={e => setRefinementPrompt(e.target.value)}
        onSubmit={updateRubric}
      />
      {/* <Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 2,
				}}>
				<Switch
					checked={publicRubric}
					onChange={() => setPublic(!publicRubric)}
				/>
				<Typography>Public </Typography>
			</Box> */}

      {settings.map(setting => (
        <SettingsMenu
          key={setting.key}
          setting={setting}
          value={rubricSettings[setting.key]}
          onChange={setting.onSelect}
        />
      ))}
    </Box>
  )
}

export default RubricEditorSettings

function SettingsMenu({ setting, onChange, value }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
      }}
    >
      <Typography fontWeight={500}>{setting.label}</Typography>
      <Select
        // size="small"
        value={value}
        onChange={onChange}
      >
        {setting.options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}
